import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EventClass;
function Event() {
  if (EventClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Event');
    EventClass = $;
  }
  return EventClass;
}
var OperationResponseClass;
function OperationResponse() {
  if (OperationResponseClass === VOID) {
    class $ {
      constructor(id, payload) {
        this.j6l_1 = id;
        this.k6l_1 = payload;
      }
      q32() {
        return this.j6l_1;
      }
    }
    initMetadataForClass($, 'OperationResponse', VOID, VOID, [Event()]);
    OperationResponseClass = $;
  }
  return OperationResponseClass;
}
var OperationErrorClass;
function OperationError() {
  if (OperationErrorClass === VOID) {
    class $ {
      constructor(id, payload) {
        this.h6l_1 = id;
        this.i6l_1 = payload;
      }
      q32() {
        return this.h6l_1;
      }
    }
    initMetadataForClass($, 'OperationError', VOID, VOID, [Event()]);
    OperationErrorClass = $;
  }
  return OperationErrorClass;
}
var OperationCompleteClass;
function OperationComplete() {
  if (OperationCompleteClass === VOID) {
    class $ {
      constructor(id) {
        this.h6n_1 = id;
      }
      q32() {
        return this.h6n_1;
      }
    }
    initMetadataForClass($, 'OperationComplete', VOID, VOID, [Event()]);
    OperationCompleteClass = $;
  }
  return OperationCompleteClass;
}
var GeneralErrorClass;
function GeneralError() {
  if (GeneralErrorClass === VOID) {
    class $ {
      constructor(payload) {
        this.u6m_1 = payload;
        this.v6m_1 = null;
      }
      q32() {
        return this.v6m_1;
      }
    }
    initMetadataForClass($, 'GeneralError', VOID, VOID, [Event()]);
    GeneralErrorClass = $;
  }
  return GeneralErrorClass;
}
var NetworkErrorClass;
function NetworkError() {
  if (NetworkErrorClass === VOID) {
    class $ {
      constructor(cause) {
        this.f6l_1 = cause;
        this.g6l_1 = null;
      }
      q32() {
        return this.g6l_1;
      }
    }
    initMetadataForClass($, 'NetworkError', VOID, VOID, [Event()]);
    NetworkErrorClass = $;
  }
  return NetworkErrorClass;
}
var StartOperationClass;
function StartOperation() {
  if (StartOperationClass === VOID) {
    class $ {
      constructor(request) {
        this.d6m_1 = request;
      }
    }
    initMetadataForClass($, 'StartOperation', VOID, VOID, [Command()]);
    StartOperationClass = $;
  }
  return StartOperationClass;
}
var RestartConnectionClass;
function RestartConnection() {
  if (RestartConnectionClass === VOID) {
    class $ {}
    initMetadataForObject($, 'RestartConnection', VOID, VOID, [Command()]);
    RestartConnectionClass = $;
  }
  return RestartConnectionClass;
}
var RestartConnection_instance;
function RestartConnection_getInstance() {
  return RestartConnection_instance;
}
var ConnectionReEstablishedClass;
function ConnectionReEstablished() {
  if (ConnectionReEstablishedClass === VOID) {
    class $ {
      constructor() {
        this.i6n_1 = null;
      }
      q32() {
        return this.i6n_1;
      }
    }
    initMetadataForClass($, 'ConnectionReEstablished', ConnectionReEstablished, VOID, [Event()]);
    ConnectionReEstablishedClass = $;
  }
  return ConnectionReEstablishedClass;
}
var CommandClass;
function Command() {
  if (CommandClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Command');
    CommandClass = $;
  }
  return CommandClass;
}
var DisposeClass;
function Dispose() {
  if (DisposeClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Dispose', VOID, VOID, [Command()]);
    DisposeClass = $;
  }
  return DisposeClass;
}
var Dispose_instance;
function Dispose_getInstance() {
  return Dispose_instance;
}
var StopOperationClass;
function StopOperation() {
  if (StopOperationClass === VOID) {
    class $ {
      constructor(request) {
        this.b6m_1 = request;
      }
    }
    initMetadataForClass($, 'StopOperation', VOID, VOID, [Command()]);
    StopOperationClass = $;
  }
  return StopOperationClass;
}
//region block: init
RestartConnection_instance = new (RestartConnection())();
Dispose_instance = new (Dispose())();
//endregion
//region block: exports
export {
  Command as Command2ao3eytvqoynn,
  ConnectionReEstablished as ConnectionReEstablishedspo1kq7uvs59,
  Dispose as Dispose3n637sa8gbmf1,
  Event as Event2qcujbxqrid4f,
  GeneralError as GeneralError1q7afgn844yvi,
  NetworkError as NetworkErrorotwtrw4n54or,
  OperationComplete as OperationComplete35pb9wj3i5rr0,
  OperationError as OperationError2sah6hjojh8as,
  OperationResponse as OperationResponseq42n5mfh87yx,
  RestartConnection as RestartConnection3ucejekzrnll6,
  StartOperation as StartOperation372o3p2p9vxt5,
  StopOperation as StopOperation41dlmx7s82zc,
  Dispose_instance as Dispose_instance2mubuj640kzg1,
  RestartConnection_instance as RestartConnection_instancezia28sn269s2,
};
//endregion

//# sourceMappingURL=WsMessage.mjs.map
